import { LeaveAreaCode, PermissionCode } from '@gb-ticket/shared-types';
import { Outlet } from 'react-router';

import { hasPermission } from '@/platform/auth/permissions';
import { useMe } from '@/platform/auth/use-me';
import { useVoiceCopy } from '@/platform/voice/use-voice';
import { OverflowTabNav } from '@/platform/components/overflow-tab-nav';
import { leaveAreaEnabled, useLeaveAreas } from '@/products/leave/features/use-leave-areas';
import {
  LEAVE_COLLEAGUES_ADMIN_CALENDAR_PATH,
  LEAVE_COLLEAGUES_CALENDAR_PATH,
  LEAVE_COLLEAGUES_PATH,
} from '@/products/leave/leave-paths';

export function LeaveColleaguesLayout() {
  const copy = useVoiceCopy();
  const me = useMe();
  const areas = useLeaveAreas();
  const calendarOn = leaveAreaEnabled(areas.data, LeaveAreaCode.CALENDAR) !== false;
  const canAdmin = hasPermission(me.data, PermissionCode.LEAVE_REQUESTS_DECIDE_ALL);
  const items = [
    { to: LEAVE_COLLEAGUES_PATH, label: 'Das Team', end: true },
    ...(calendarOn ? [{ to: LEAVE_COLLEAGUES_CALENDAR_PATH, label: 'Kalenderansicht' }] : []),
    ...(calendarOn && canAdmin
      ? [{ to: LEAVE_COLLEAGUES_ADMIN_CALENDAR_PATH, label: 'Kalenderansicht (Verwaltung)' }]
      : []),
  ];

  return (
    <div className="min-w-0 space-y-6">
      <OverflowTabNav ariaLabel={copy('leave.colleagues.title')} items={items} />
      <Outlet />
    </div>
  );
}
